import { Component } from 'preact';
import { Link } from 'preact-router';
import Wheel from './Wheel';
import Options from './Options';
import StatsBox from './StatsBox';
import Commentary from './Commentary';
import { deselectCountry, resetMap } from '../lib/worldmap';
import { getValueGrouping } from '../lib/utils';
import { RESOURCES, UNREST } from '../lib/options-config';

const ALL_TYPES = [...RESOURCES, ...UNREST];
const UNREST_SUICIDE = UNREST.find(({ key }) => key === 'suicide');

export default class Country extends Component {
  state = {
    selectedOptions: 'resource',
    wheelItems: UNREST
  }

  onOptionChange = ({ name, checked }) => {
    // console.log('onOptionChange', { name, checked });

    // this.setState({
    //   `option-${name}`: checked
    // });

    const collection = this.state.selectedOptions === 'resource' ? RESOURCES : UNREST;
    const item = collection.find(({ key }) => key === name);

    item.checked = checked;

    const wheelItems = this.configureWedges(this.props.country, this.props.year);

    // console.log('onOptionChange', {wheelItems});
    this.setState({ wheelItems });
  }

  onSelect = (collectionName) => {
    if (this.state.selectedOptions !== collectionName) {
      this.setState({ selectedOptions: collectionName });

      const wheelItems = this.configureWedges(this.props.country, this.props.year);

      // console.log('onSelect', {wheelItems});
      this.setState({ wheelItems });
    }
  }

  getOptions () {
    return this.state.selectedOptions === 'unrest' ? UNREST : RESOURCES;
  }

  getCheckedOptions () {
    return this.getOptions().filter(({ checked = true }) => checked);
  }

  getCheckedOptionNames () {
    return this.getCheckedOptions().map(({ key }) => key);
  }

  getTotalDeaths (eventsByYear) {
    if (!eventsByYear || !eventsByYear.length) {
      return 0;
    }

    const checkedOptions = this.getCheckedOptionNames();
    
    // don't count suicides if option is displayed and unchecked
    const includeSuicides = this.getOptions() !== UNREST || checkedOptions.includes('suicide');

    return eventsByYear.reduce((total, event) => {
      // event type option is checked
      if (checkedOptions.some(option => event[`is ${option}`]) || includeSuicides && event['num suicide']) {
        const deaths = event['num dead'] || 0;
        const suicides = includeSuicides && event['num suicide'] || 0;

        return total + deaths + suicides;
      }

      return total;
    }, 0);
  }

  getEventKeys (event, includeList = []) {
    return Object.keys(event)
      .filter(key =>
        key.startsWith('is ') && (!includeList.length || includeList.includes(key))
      )
      .map(key => key.slice(3))
      .sort();
  }

  _createGroupedItem (eventKeys) {
    const chars = [];
    const labels = [];

    eventKeys.forEach(key => {
      const { char, label } = ALL_TYPES.find(item => item.key === key);

      chars.push(char);
      labels.push(label || key[0].toUpperCase() + key.slice(1));
    });

    // console.log('group', { eventKeys, chars, labels })

    return {
      key: eventKeys.join('-'),
      char: chars.join(''),
      label: labels.join(' / '),
      value: 0,
      deaths: 0,
      suicides: 0
    };
  }

  getValuesGrouped (collection, eventsByYear) {
    if (!eventsByYear || !eventsByYear.length) {
      return [];
    }

    const checkedOptions = this.getCheckedOptionNames();
    
    // don't count suicides if option is displayed and unchecked
    const includeSuicides = this.getOptions() !== UNREST || checkedOptions.includes('suicide');

    const collectionKeys = collection.map(({ key }) => `is ${key}`);

    const total = eventsByYear.reduce((total, event) => {
      const deaths = event['num dead'] || 0;
      const suicides = includeSuicides && event['num suicide'] || 0;

      if (!deaths && !suicides) {
        return total;
      }

      const eventKeys = this.getEventKeys(event, collectionKeys)
      .filter(key => checkedOptions.includes(key));

      if (!eventKeys.length) {
        if (suicides) {
          eventKeys.push('suicide');
        }

        else {
          return total;
        }
      }

      const key = eventKeys.join('-');
      let item = total.find(item => item.key === key);

      if (!item) {
        item = this._createGroupedItem(eventKeys);
        total.push(item);
      }

      item.deaths += deaths;
      item.suicides += suicides;
      item.value += deaths + suicides;

      return total;
    }, []);

    return total.sort((a, b) => b.value - a.value);
  }

  getValuesByCollection (collection, eventsByYear) {
    if (!eventsByYear || !eventsByYear.length) {
      return [];
    }

    const checkedOptions = this.getCheckedOptionNames();
    
    // don't count suicides if option is displayed and unchecked
    const includeSuicides = this.getOptions() !== UNREST || checkedOptions.includes('suicide');

    const values = collection.map(item => ({
      ...item,
      value: 0
    }));

    const suicideItem = values.find(item => item.key === 'suicide');

    eventsByYear.forEach(event => {
      const deaths = event['num dead'];
      const suicides = event['num suicide'];

      Object.keys(event)
      .filter(prop => prop.startsWith('is ') && event[prop] === true)
      .forEach(prop => {
        const key = prop.slice(3);
        const item = values.find(item => item.key === key);

        if (item) {
          if (deaths && item.key !== 'suicide') {
            item.value += deaths;
          }

          if (suicides && (item.key === 'suicide' || includeSuicides)) {
            item.value += suicides;
          }
        }
      });

      if (suicideItem && suicides) {
        suicideItem.value += suicides;
      }
    });

    return values.map(item => ({
      ...item,
      valueGroup: getValueGrouping(item.value)
    }));
  }

  configureWedges (country, year) {
    const wedgeCollection = this.state.selectedOptions === 'unrest' ?
      RESOURCES : UNREST;
    const eventsByYear = country.eventsByYear[year];

    if (!eventsByYear) {
      return wedgeCollection;
    }

    return this.getValuesByCollection(wedgeCollection, eventsByYear);
  }

  componentWillMount () {
    const { country, year } = this.props;
    
    if (country && year) {
      const wheelItems = this.configureWedges(country, year);

      // console.log('Country componentWillMount', {wheelItems});
      this.setState({ wheelItems });
    }
  }

  componentWillReceiveProps ({ country, year }) {
    if (country && year) {
      const wheelItems = this.configureWedges(country, year);

      // console.log('Country componentWillReceiveProps', {wheelItems});
      this.setState({ wheelItems });
    }
  }

  render (props, state) {
    const { country, year } = props;
    const { selectedOptions, wheelItems } = state;

    if (!country) {
      return null;
    }

    const eventsByYear = country.eventsByYear[year];
    const totalDeaths = this.getTotalDeaths(eventsByYear);
    const summaryTotals = this.getValuesGrouped(this.getOptions(), eventsByYear);
    const commentaries = eventsByYear && eventsByYear
    .map(event => event.commentary)
    .filter(commentary => !!commentary);
    
    // console.log('Country', country.name, selectedOptions, eventsByYear);

    return <div class="Country">
      <h2>{country.name}</h2>

      <Wheel radius={ 50 } segments={ wheelItems } visible={ !!totalDeaths } fadeIn={ 620 } />

      <div class="country-options">
        <Options name="resource" title="Resource" items={ RESOURCES } disabled={ selectedOptions !== 'resource' } onSelect={ this.onSelect } onInput={ this.onOptionChange } tabIndex="0" />
        <Options name="unrest" title="Unrest" items={ UNREST } disabled={ selectedOptions !== 'unrest' } onSelect={ this.onSelect } onInput={ this.onOptionChange } tabIndex="0" />
      </div>

      <StatsBox year={ year } totalDeaths={ totalDeaths } totals={ summaryTotals } visible={ !!totalDeaths } fadeIn={ 620 }>
        {
          commentaries && commentaries.length > 0 &&
          <a class="commentary-link" href="#commentary">
            <span class="icon-commentary"></span> <span class="label">Commentary</span>
          </a>
        }
      </StatsBox>

      <Commentary items={commentaries} />
    </div>;
  }
}



// WEBPACK FOOTER //
// ./components/Country.js